import { computed, getCurrentInstance } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";

export const useCreditCardAssignment = () => {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();
  const creditCards = computed(() => (vm ? (vm.$store.state as StateRoot).creditCards : []));

  const getCreditCardAssignment = async (
    fields: FragmentFields<CreditCardAssignment> = ["id", "paymentSystemId", "cardNumberEnding"]
  ) => {
    if (!authUser.value) return;
    const response = await providers.CreditCardAssignmentsProvider.findAll({ userId: authUser.value.id }, fields);
    vm?.$store.commit(MUTATION_TYPES.SET_CREDIT_CARDS, response);
  };

  const getCreditCardsBySystemId = (systemId: string): CreditCardAssignment | undefined => {
    return creditCards.value.filter(i => i.paymentSystemId === systemId)[0];
  };

  return { creditCards, getCreditCardAssignment, getCreditCardsBySystemId };
};
